import { PLAYLIST_ITEMS_RESOURCE, PLAYLISTS_RESOURCE } from "../api/resources";
import {
  addResource,
  deleteResource,
  fetchResource,
  updateResource,
  putResource,
} from "./remote";
import { API_ROOT } from "signoxe/constants/config";
import { actions as notifActions } from "redux-notifications";
import { fetchAll } from "signoxe/actions/fetchAll";
import {
  SEARCH_PLAYLISTS,
  FILTER_PLAYLISTS,
  FETCH_EVENTS_LOCATIONS
} from "signoxe/constants/actionTypes";
import { fetchPlaylistsV2, fetchPlaylistDetail } from "./playlistV2";

export const fetchPlaylists = fetchResource(PLAYLISTS_RESOURCE);
export const fetchPagedPlayists = (url) =>
  fetchResource(PLAYLISTS_RESOURCE, false, url)();

const PLAYLIST_ID = localStorage.getItem("playlist_id")
console.log("playlist+id", PLAYLIST_ID)

// export const updatePlaylist = updateResource(PLAYLISTS_RESOURCE);

export const addPlaylist = addResource(PLAYLISTS_RESOURCE);

export const deletePlaylist = deleteResource(PLAYLISTS_RESOURCE);

export const clonePlaylist = addResource(PLAYLISTS_RESOURCE, "clone");

export const deletePlaylistItem = deleteResource(PLAYLIST_ITEMS_RESOURCE);

export const updatePlaylistItem = updateResource(PLAYLIST_ITEMS_RESOURCE);

export const addPlaylistItem = addResource(PLAYLIST_ITEMS_RESOURCE);

export const filterPlaylistByTag = (tag) => ({
  type: FILTER_PLAYLISTS,
  filterBy: "TAGS",
  filter: tag,
});

export const setPlaylistTags = putResource({
  resource: PLAYLISTS_RESOURCE,
  subResource: "tags",
  route: "detail",
});

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem("token")}`;

const { notifSend } = notifActions;

export const searchPlaylists = (query) => ({ type: SEARCH_PLAYLISTS, query });

export const updatePlaylistTags = (playlist, data) => (dispatch) => {
  const url = `${API_ROOT}playlists/${playlist.id}/tags/`;
  const options = {
    method: "PUT",
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(data),
  };
  fetch(url, options)
    .then((response) => {
      dispatch(fetchPlaylistsV2());
      if (response.status == 400) {
        alert("Invalid");
      }
    })
    .catch((err) => {
      alert(err);
    });
};

export const bulkUpdatePlaylist = (data) => (dispatch) => {
  var sentData = {
    data: data,
  };
  if (data.length == 0) {
    dispatch(
      notifSend({
        message: "No Playlist(s) Edited!.",
        kind: "alert",
        dismissAfter: 5000,
      })
    );
    return;
  }

  const url = `${API_ROOT}bulk_update/playlist/`;
  const options = {
    method: "PATCH",
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(sentData),
  };
  fetch(url, options)
    .then((response) => {
      dispatch(fetchPlaylistsV2(true));
      if (response.status == 400) {
        alert("Invalid");
      }
    })
    .catch((err) => {
      alert(err);
    });
};

export const bulkDeletePlaylist = (data) => (dispatch) => {
  var sentData = {
    data: data,
  };

  if (data.length == 0) {
    dispatch(
      notifSend({
        message: "No Playlist(s) Selected!",
        kind: "alert",
        dismissAfter: 5000,
      })
    );
    return;
  }

  const url = `${API_ROOT}bulk_delete/playlist/`;
  const options = {
    method: "DELETE",
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(sentData),
  };
  fetch(url, options)
    .then((response) => {
      dispatch(fetchPlaylistsV2());
      if (response.status == 500) {
        alert("Something went wrong");
      }
    })
    .catch((err) => {
      alert(err);
    });
};

export const bulkDeletePlaylistItems = (data) => (dispatch) => {
  var sentData = {
    data: data,
  };

  if (data.length == 0) {
    dispatch(
      notifSend({
        message: "No Item(s) Selected!",
        kind: "alert",
        dismissAfter: 5000,
      })
    );
    return;
  }

  const url = `${API_ROOT}bulk_delete/playlistitems/`;
  const options = {
    method: "DELETE",
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(sentData),
  };
  fetch(url, options)
    .then((response) => {
      dispatch(fetchPlaylistsV2());
      const playlistId = localStorage.getItem("playlist_id");
      dispatch(fetchResource(PLAYLISTS_RESOURCE, true)(true, playlistId));
      if (response.status == 500) {
        alert("Something went wrong");
      }
    })
    .catch((err) => {
      alert(err);
    });
};

export const setEventLocations = (locations) => ({
  type: FETCH_EVENTS_LOCATIONS,
  payload: locations,
});

export const fetchEventLocations = async () => {
  const url = `${API_ROOT}event/locations/`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: getAuthTokenHeader(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Error fetching event locations:', err);
    throw err;
  }
};





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/playlist.js